import React from 'react';
import Select from 'react-select';
import FormControl from 'react-bootstrap/FormControl';

import Display from '../../../util/Display';
import RegEx from '../../../util/RegEx';
import Const from '../../../util/Constants';

class FieldAssigmentItem extends React.Component {

  constructor(props) {
    super(props);

    this.formats = [
      { label: 'DD/MM/YYYY', value: 'DD/MM/YYYY' },
      { label: 'DD/MM/YYYY HH:mm:ss', value: 'DD/MM/YYYY HH:mm:ss' },
      { label: 'DD/MM/YYYY hh:mm:ss a', value: 'DD/MM/YYYY hh:mm:ss a' },
      { label: 'DD/MM/YY', value: 'DD/MM/YY' },
      { label: 'DD/MM/YY HH:mm', value: 'DD/MM/YY HH:mm' },
      
      { label: 'MM/DD/YYYY', value: 'MM/DD/YYYY' },
      { label: 'MM/DD/YYYY HH:mm:ss', value: 'MM/DD/YYYY HH:mm:ss' },
      { label: 'MM/DD/YYYY hh:mm:ss a', value: 'MM/DD/YYYY hh:mm:ss a' },
      { label: 'MM/DD/YY', value: 'MM/DD/YY' },
      { label: 'MM/DD/YY HH:mm', value: 'MM/DD/YY HH:mm' },

      { label: 'YYYY/MM/DD', value: 'YYYY/MM/DD' },
      { label: 'YYYY/MM/DD HH:mm:ss', value: 'YYYY/MM/DD HH:mm:ss' },
      { label: 'YYYY/MM/DD hh:mm:ss a', value: 'YYYY/MM/DD hh:mm:ss a' },
      { label: 'YY/MM/DD', value: 'YY/MM/DD' },
      { label: 'YY/MM/DD HH:mm', value: 'YY/MM/DD HH:mm' }
    ];

    let format = null;
    let zone = null;
    if(props.value && props.value.field && props.api_data && props.api_data[props.value.field.value]) {
      format = this.formats.find(format => format.value === props.api_data[props.value.field.value].format);
      zone = props.zones.find(zone => zone.value === props.api_data[props.value.field.value].zone);
    }

    this.state = { index: props.index, key: props.value.key, field: props.value.field, format , zone };
  }

  UNSAFE_componentWillReceiveProps(props) {
    let format = null;
    let zone = null;
    if(props.value && props.value.field && props.api_data && props.api_data[props.value.field.value]) {
      format = this.formats.find(format => format.value === props.api_data[props.value.field.value].format);
      zone = props.zones.find(zone => zone.value === props.api_data[props.value.field.value].zone);
    }
    
    this.setState({ index: props.index, key: props.value.key, field: props.value.field, format, zone });
  }

  keyChange = key => {
    key = key.trim();
    if(RegEx.isMatch(key, false, '^[a-zA-Z0-9_.]*$')) {
      this.setState({ ...this.state, key });
      const field = this.state.field !== undefined ? this.state.field.value : '';
      this.props.onEdit(this.state.index, { key, field });
    }
  }

  fieldChange = field => {
    const isDate = field && (field.type === Const.DateTime || field.type === Const.Date);
    if(isDate) {
      const format = this.formats[0];
      const zone = this.props.dZone
      this.setState({ ...this.state, field, format, zone  });
      this.props.onEdit(this.state.index, { key: this.state.key, field: field.value});
      this.props.onFormat(field.value, format, zone);
    } else {
      this.setState({ ...this.state, field, format: null, zone: null });
      this.props.onEdit(this.state.index, { key: this.state.key, field: field.value});
    }
  }

  onFormatChange = format => {
    this.setState({ ...this.state, format });
    this.props.onFormat(this.state.field.value, format, this.state.zone);
  }

  onZoneChange = zone => {
    this.setState({ ...this.state, zone });
    this.props.onFormat(this.state.field.value, this.state.format, zone);
  }
  
  render() {
    const isDate = this.state.field && ( this.state.field.type === Const.DateTime || this.state.field.type === Const.Date );
    return (
      <div className="formhead col-md-12">
        <div className="row">
          <div className="col-md-2">
            <FormControl type="text" placeholder="Key" value={this.state.key} className="mr-sm-2"
              onChange={ event => this.keyChange(event.target.value) } />
          </div>
          <div className={`col-md-${isDate ? '2' : '4'}`}>
            <Select value={this.state.field} onChange={this.fieldChange}
              options={this.props.fields} isSearchable={true} />
          </div>
          { isDate ?
            <>
              <div className="col-md-3">
                <Select value={this.state.format} onChange={select => this.onFormatChange(select)}
                  options={this.formats} isSearchable={true} isClearable={true} />
              </div>
              <div className="col-md-3">
                <Select value={this.state.zone} onChange={select => this.onZoneChange(select)}
                  options={this.props.zones} isSearchable={true} isClearable={true} />
              </div>
            </>
            : null
          }
          { Display.MultiAction(this.props.index, this.props.onAdd, this.props.onDelete) }
        </div>
      </div>
    );
  }
}
export default FieldAssigmentItem;